import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
    this.boundDismiss = () => this.dismiss()
    this.element.addEventListener("click", this.boundDismiss)
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.element.removeEventListener("click", this.boundDismiss)
  }

  dismiss() {
    this.element.remove()
  }

  stop(event) {
    event.stopPropagation()
  }
}
